<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MCompanyEditor"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="company"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <MCompanyEditorFieldset
          :item="editor"
          :formId="formId"
          :target="target"
        >
        </MCompanyEditorFieldset>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.company || !forms.company.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MCompanyEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const [editor] = args
    console.log(editor)
    return {
      id: editor.id,
      etag: editor.getETAG(),
      ...editor.getChanges({ skipEmbeddedLists: true })
    };
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  defaultTitle!: any;
  targetConfig!: any;
  editor!: any;

  async $$load_editor() {
    return this.item.editor()
  }

  ux!: any;
  dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'editor', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        defaultTitle: this.$fn.pgettext("Company", "Edit General Information"),
        targetConfig: {
          general: {
            title: this.$fn.pgettext("Company", "Edit general data"),
            fieldsToSubmit: ["*"
              ,
            ]
            ,
          }
          ,
        }
        ,
        editor: null,
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2688_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2688, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_2694_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_2694, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_2692_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_2692, alias=save
    return {
      objectType: "company",
      op: "upsert",
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_2696_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_2696, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2688: actions.CloseModalAction;
    evh_7315092382398562_close_2687: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2690: actions.CloseModalAction;
    evh_2248226175642056_close_2689: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_2694: actions.CloseModalAction;
    evh_1040167445267876_success_2693: actions.EventHandlerImpl;
    act_1040167445267876_crud_2692: actions.CRUDAction;
    evh_1040167445267876_submit_2691: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_2696: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_2695: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2688 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2688_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2687 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2688,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2687],
      }
    );
    const act_2248226175642056_closeModal_2690 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2689 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2690,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2689],
      }
    );
    const act_1040167445267876_closeModal_2694 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_2694_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2693 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_2694,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_2692 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_2692_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_2693],
      }
    );
    const evh_1040167445267876_submit_2691 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_2692,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2691],
      }
    );
    const act_1419464017721962_closeModal_2696 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_2696_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2695 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_2696,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2695],
      }
    );
    return {
      act_7315092382398562_closeModal_2688,
      evh_7315092382398562_close_2687,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2690,
      evh_2248226175642056_close_2689,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_2694,
      evh_1040167445267876_success_2693,
      act_1040167445267876_crud_2692,
      evh_1040167445267876_submit_2691,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_2696,
      evh_1419464017721962_clickPreventStop_2695,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_2692,
    }
  }
}

Vue.component("MCompanyEditor", MCompanyEditor);

</script>